import { Redirect, Route } from "react-router";

import useAuth from "../hooks/use-auth";

const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const { isLogin } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) =>
        isLogin() && restricted ? <Redirect to="/" /> : <Component {...props} />
      }
    />
  );
};

export default PublicRoute;
